import React from 'react';
import PropTypes from 'prop-types';
import { TableWrapper, StyledTable, TH, TR, TD, PaginationRow, PaginationButton } from './components/TableDataStyles';
import { formatCellData, getPaginationRange } from './utils/tableDataHelpers';
import Text from '../../atoms/Text';
import LoadingContainer from '../LoadingContainer';
import Icon from '../../atoms/Icon';

const TableData = ({
  columns,
  data,
  loading,
  emptyMessage,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const renderPagination = () => {
    if (!totalPages || totalPages <= 1) return null;
    const range = getPaginationRange(currentPage, totalPages);

    return (
      <PaginationRow>
        <PaginationButton 
          disabled={currentPage === 1} 
          onClick={() => onPageChange(currentPage - 1)}
          aria-label="Previous page"
        >
          <Icon className="fas fa-chevron-left" size="xs" color="inherit" />
        </PaginationButton>
        
        {range.map((page, index) => {
          if (page === '...') {
            return <Text key={`ellipsis-${index}`} size="sm" color="text.muted">...</Text>;
          }
          return (
            <PaginationButton 
              key={`page-${page}`} 
              active={currentPage === page}
              onClick={() => onPageChange(page)}
            >
              {page}
            </PaginationButton>
          );
        })}
        
        <PaginationButton 
          disabled={currentPage === totalPages} 
          onClick={() => onPageChange(currentPage + 1)}
          aria-label="Next page"
        >
          <Icon className="fas fa-chevron-right" size="xs" color="inherit" />
        </PaginationButton>
      </PaginationRow>
    );
  };

  return (
    <TableWrapper>
      <LoadingContainer loading={loading} minHeight="200px">
        <StyledTable>
          <thead>
            <tr>
              {columns.map((col, index) => (
                <TH key={`th-${index}`}>{col.header}</TH>
              ))}
            </tr>
          </thead>
          <tbody>
            {!loading && data.length === 0 ? (
              <tr>
                <TD colSpan={columns.length} style={{ textAlign: 'center', padding: '48px 0' }}>
                  <Text size="md" color="text.muted">{emptyMessage}</Text>
                </TD>
              </tr>
            ) : (
              data.map((row, rowIndex) => (
                <TR key={row.id || `tr-${rowIndex}`}>
                  {columns.map((col, colIndex) => (
                    <TD key={`td-${rowIndex}-${colIndex}`}>
                      {col.render 
                        ? col.render(row) 
                        : formatCellData(row[col.accessor], col.type)}
                    </TD>
                  ))}
                </TR>
              ))
            )}
          </tbody>
        </StyledTable>
        {renderPagination()}
      </LoadingContainer>
    </TableWrapper>
  );
};

TableData.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      accessor: PropTypes.string,
      type: PropTypes.oneOf(['text', 'currency', 'date']),
      render: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  emptyMessage: PropTypes.string,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  onPageChange: PropTypes.func,
};

TableData.defaultProps = {
  loading: false,
  emptyMessage: 'Nenhum registro encontrado.',
  currentPage: 1,
  totalPages: 1,
  onPageChange: () => {},
};

export default TableData;



// WEBPACK FOOTER //
// ./src/design-system/molecules/TableData/TableData.jsx